import { useTranslation } from '@cobliteam/i18n/src/hooks/useTranslation';
import { Typography } from '@cobliteam/ui/components';
import Link from '@cobliteam/ui/components/Link';
import Popover from '@cobliteam/ui/components/Popover';
import IButtonImg from './ibutton-img.png';

export const IdentifierPopoverContent: React.FC = () => {
  const { t } = useTranslation('drivers');

  return (
    <div className='flex w-80 flex-col justify-center gap-4'>
      <Typography variant='description-title'>{t('vincule_o_identificador_ao_motorista')}</Typography>
      <Typography variant='body'>
        {t('para_vincular_o_identificador_ibutton_clique_em')}
        <strong> {t('edit')}</strong> {t('motorista_e_selecione_o_codigo_de')}
        <strong> {t('4_digitos_presente_na_etiqueta_do_identificador')}</strong> {t('voce_pode_digitar_para_filtrar_a_lista_de_identificadores')}
      </Typography>
      <Link size='sm' target='_blank' rel='noopener noreferrer' href='https://suporte.cobli.co/pt-BR/articles/4616057-identificador-de-motoristas-faq-e-manual-de-uso'>
        {t('para_saber_mais_sobre_identificadores_clique_aqui')}
      </Link>
      <img src={IButtonImg} alt='iButton' className='self-center' />
    </div>
  );
};

const PopoverIButtonIdentifier = ({ portal }: { portal?: boolean }) => (
  <Popover>
    <Popover.Trigger>
      <Popover.Icon />
    </Popover.Trigger>
    <Popover.Content align='center' side='right' portal={portal}>
      <IdentifierPopoverContent />
    </Popover.Content>
  </Popover>
);

export default PopoverIButtonIdentifier;
